<template>
  <b-card>
    <div style="position: relative">
      <!-- <loading-overlay :loading="loading" />
      {{ count }} -->
        
      <div class="d-flex justify-content-end">
        <b-button
          v-if="!isEditing"
          variant="primary"
          class="d-flex align-items-center"
          @click="onEditClicked"
        >
          <feather-icon icon="EditIcon" class="mr-50" />
          تعديل
        </b-button> 
       
        
        <div v-else class="d-flex">
          <b-button
            @click="isEditing = false"
            variant="outline-secondary"
            class="d-flex mx-50 align-items-center"
          >
            <feather-icon icon="EditIcon" class="mr-50" />
            إلغاء
          </b-button>
          <!-- <save-btn
            :loading="working"
            @click="onUpdateConfirmed"
            variant="success"
          /> -->
          <span
            :title="
              count > 1000
                ? 'لا يمكن إدخال أكثر من 1000 حرف'
                : ''
            "
            v-b-tooltip.hover.v-warning.bottom
          >
            <b-button
              variant="success"
              
              @click="onUpdateConfirmed"
              v-can="{ slug: $route.meta.slug, action: 'C' }"
              :disabled="count > 1000"
            >
              <span v-if="working">
                جاري الحفظ
              </span>
              <span v-else>
                <feather-icon icon="PlusIcon" class="mr-50" />
                حفظ
              </span>
              
            </b-button>
          </span>
        </div>
      </div>
      <b-form-group
        v-if="isEditing"
        label="لمحة عن المنظمة"
        label-for="about-content"
      >
        <validation-observer ref="aboutValidation">
          <validation-provider
            #default="{ errors }"
            name="لمحة عن المنظمة"
            rules="required"
            id="about-content"
            mode="passive"
          >
            <quill-editor
              v-model="about"
              :class="{ quillEditor: errors.length > 0 }"
              :options="editorOption"
              
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </validation-observer>
      </b-form-group>
      <article class="p-1 border my-1" v-else v-html="aboutContent"></article>
    </div>
  </b-card>
</template>
<script>
import { BCard, BFormGroup, BButton , VBTooltip } from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import saveBtn from "@/components/loader-btn";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

import { required } from "@validations";

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    saveBtn,
    quillEditor,
    ValidationObserver,
    ValidationProvider,
    LoadingOverlay,
  },

  data() {
    return {
      about: "",
      count:0 , 
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
      isEditing: false,
      required,
    };
  },

  computed: {
    ...mapGetters("manageInterfaceNgo/About", [
      "aboutContent",
      "loading",
      "working",
    ]),
  },
  watch: {
    about(value) {
      var textWithinTags = value.replace(/<[^>]*>/g, '');
      var numberOfCharacters = textWithinTags.length;
      this.count = numberOfCharacters;
      console.log(numberOfCharacters);

    },
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  methods: {
    ...mapActions("manageInterfaceNgo/About", [
      "fetchAboutContent",
      "updateAboutContent",
    ]),
    onEditClicked() {
      this.about = this.aboutContent;
      this.isEditing = true;
    },
    onUpdateConfirmed() {
      this.$refs.aboutValidation.validate().then(async (success) => {
        if (success) {
          this.updateAboutContent(this.about).then(() => {
            this.isEditing = false;
          });
        }
      });
    },
  },

  created() {
    this.fetchAboutContent();
  },
};
</script>
